import script from './component-lib.esm77.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    staticClass: "icon-jotform",
    attrs: {
      "viewBox": "0 0 304.04 334.44"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Jotform'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M83.31,317.83c6.31,6.12,1.85,16.61-7.12,16.61H20.08C9,334.44,0,325.71,0,315v-54.4c0-8.69,10.82-13,17.13-6.9Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M171,322.07a42.06,42.06,0,0,1,0-59.76L231,202.76a42.71,42.71,0,0,1,60.15,0,42.07,42.07,0,0,1,0,59.75l-60,59.56A42.73,42.73,0,0,1,171,322.07Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.66,172.43a42.06,42.06,0,0,1,0-59.76L113.54,12.38a42.71,42.71,0,0,1,60.15,0,42.05,42.05,0,0,1,0,59.75L72.81,172.43A42.73,42.73,0,0,1,12.66,172.43Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M95.13,243.91a42.06,42.06,0,0,1,0-59.76L231.43,48.73a42.73,42.73,0,0,1,60.15,0,42.06,42.06,0,0,1,0,59.76L155.28,243.91A42.73,42.73,0,0,1,95.13,243.91Z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-15f79f4c";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var JotformIcon = __vue_component__;
export { JotformIcon as default };